import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const BetGliderIcon = observer('BetGliderIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <rect
                width='16'
                height='16'
                fill='#e30613'
                rx='8'
            />
            <g clipPath='url(#betGliderIconClipPath)'>
                <path
                    fill='#fff'
                    d='m4.745 9.596 4.32-1.595L5.38 6.405l.412-2.072.768.334 4.114 1.783c.59.251.882.86.745 1.55-.138.69-.67 1.295-1.36 1.55l-2.174.805-2.651.979-.9.333z'
                />
            </g>
            <defs>
                <clipPath id='betGliderIconClipPath'>
                    <path
                        fill='#fff'
                        d='M4 4h8v8H4z'
                    />
                </clipPath>
            </defs>
        </SvgElement>
    );
});
